import RTypeDetectionTrend from './RTypeDetectionTrend';

export default RTypeDetectionTrend;
